import React, {Component} from 'react';
import {Button} from "reactstrap";
import {Image} from '../common/Image';

class SquareButtonX extends Component {

	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {

		let cloneProps = Object.assign({}, this.props);

		if (cloneProps.title) {
			cloneProps.toggle = "tooltip";
			cloneProps.placement = "top";
			cloneProps.rel = "tooltip";
		}

		return (
			<div>
				<Button {...cloneProps} style={this.props.style ? this.props.style : {}} className={this.props.className ? this.props.className : "stickButton"}>
					{this.props.img &&
					<Image className="simple-text logo-mini"
						 src={this.props.img && process.env.REACT_APP_CONTEXT_NAME + "/image/" + this.props.img}
						 style={{marginRight: '10px'}}
					/>}
					{this.props.fontAwesomeClass &&
					<i className={this.props.fontAwesomeClass}/>}
					<span style={{fontSize: 'medium', color: 'black'}}></span>
					{this.props.label}
				</Button>
			</div>
		)
	}
}

export default SquareButtonX;